import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const AnalisarAlteracaoService = {
  async getById(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`analisarperiodo/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async aprovarAlteracao(id) {
    const postData = { _method: "PUT" };
    const response = await BaseService.fetchResponseFromAPIPost(
      `analisarperiodo/aprovar/${id}`,
      JSON.stringify(postData),
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    SnackBarModule("Aprovado com sucesso", "success");
    return true;
  },

  async aprovarAlteracaoV2(id) {
    const postData = { _method: "PUT" };
    const response = await BaseService.fetchResponseFromAPIPost(
      `analisarperiodo/aprovar/v2/${id}`,
      JSON.stringify(postData),
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    SnackBarModule("Aprovado com sucesso", "success");
    return true;
  },

  async recusarAlteracao(id, postData) {
    postData.append("_method", "PUT");
    const response = await BaseService.fetchResponseFromAPIPost(
      `analisarperiodo/recusar/${id}`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.error, "error");
      return false;
    }
    SnackBarModule("Recusado com sucesso", "success");
    return true;
  },
}